import { runExpertMethod } from '../colorExpertUtils';
import { sanitizeRgbColors } from '../lightingColorSanitize';

/**
 * Resolve Jules suggestion colors: prefer expert method, else sanitize AI RGB.
 */
export function resolveSuggestionColors(event, numZones = 4) {
	if (event?.expertMethodId) {
		const result = runExpertMethod(event.expertMethodId, { r: 128, g: 128, b: 128 }, numZones);
		if (result?.type === 'look' && result.colors?.length) {
			return { colors: result.colors, type: 'look', looks: null };
		}
		if (result?.type === 'cycle' && result.looks?.length) {
			return { colors: result.looks[0]?.colors || [], type: 'cycle', looks: result.looks };
		}
	}
	return {
		colors: sanitizeRgbColors(event?.colors || [], numZones),
		type: 'look',
		looks: null,
	};
}
